// App
import type React from 'react';
import { useSelector } from 'react-redux';

// Constellation
import { Heading, TextButton } from '@zillow/constellation-10';

// Misc / utils

// Types
import type { State } from 'app/shared/types/State';

type LinkType = {
  text: string | React.ReactNode;
  url: string;
  label: string;
};
const AreaLinks = () => {
  const area = useSelector((state: State) => state.address);

  const links: Array<LinkType> = [
    {
      text: (
        <>
          What is the Rent Zestimate<sup>®</sup>?
        </>
      ),
      url: 'https://www.zillow.com/rental-manager/resources/what-is-the-rent-zestimate/',
      label: 'WhatIsTheRentZestimate',
    },
    {
      text: 'Determining Rental Price Tutorial',
      url: 'https://www.zillow.com/rental-manager/resources/how-much-can-i-rent-my-house-for/',
      label: 'DeterminingRentalPriceTutorial',
    },
    {
      text: 'Guide to Raising Rent',
      url: 'https://www.zillow.com/rental-manager/resources/raising-rent/',
      label: 'GuideToRaisingRent',
    },
    {
      text: 'Collect Rent Online with Zillow',
      url: 'https://www.zillow.com/rental-manager/resources/collect-rent-online/',
      label: 'CollectRentOnlineWithZillow',
    },
    {
      text: 'Landlord Tools & Resources',
      url: 'https://www.zillow.com/rental-manager/resources/tools-forms/',
      label: 'LandlordToolsResources',
    },
  ];

  if (!area || !links) {
    return null;
  }
  const areaName = area.city && area.state && `${area.city}, ${area.state}`;

  return (
    <div>
      <Heading level={3} textStyle="responsive.heading-md" css={{ marginBottom: '600' }}>
        Resources for Pricing and Renting your Property
      </Heading>
      {links.map((link, idx) => {
        return (
          <div key={`${areaName}-link-${link.url}-${idx}`}>
            <TextButton asChild textStyle="body" css={{ marginTop: '400' }}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.text}
              </a>
            </TextButton>
          </div>
        );
      })}
    </div>
  );
};

export default AreaLinks;
